// Les erreurs platform-api ont la forme { error: { code, message, details } } (AppError.toJSON de @logistech/shared)
interface HttpLikeError {
  response?: { status?: number; data?: { error?: { code?: string; message?: string; details?: unknown } } };
}

/** undefined = pas de réponse HTTP (réseau coupé, proxy injoignable, timeout). */
export const httpStatus = (err: unknown): number | undefined => (err as HttpLikeError | null)?.response?.status;

export const serverMessage = (err: unknown): string | undefined =>
  (err as HttpLikeError | null)?.response?.data?.error?.message;

/** Code applicatif de l'erreur (ex. INVALID_CURRENT_PASSWORD), undefined sans corps d'erreur platform-api. */
export const serverCode = (err: unknown): string | undefined => (err as HttpLikeError | null)?.response?.data?.error?.code;

export const serverDetails = (err: unknown): unknown => (err as HttpLikeError | null)?.response?.data?.error?.details;

/** Messages communs aux formulaires d'auth : seul le cas 401 est propre à chaque écran. */
export const genericErrorMessage = (err: unknown): string => {
  const status = httpStatus(err);
  if (status === undefined) return 'Connexion impossible, vérifiez votre réseau';
  if (status === 429) return 'Trop de tentatives, réessayez dans quelques minutes';
  if (status >= 500) return 'Service momentanément indisponible';
  return 'Une erreur est survenue, réessayez';
};
